import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rProje } from '../../../../api/models/rProje';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rProje[]>, rProje[]>(
  ActionSubTypes.API_PROJELISTELE,
  DefaultInputDataStateModel<pList, rProje[]>()
);
